import { render } from "./CircleChart.vue?vue&type=template&id=5b718fc8&scoped=true"
import script from "./CircleChart.vue?vue&type=script&lang=js"
export * from "./CircleChart.vue?vue&type=script&lang=js"

import "./CircleChart.vue?vue&type=style&index=0&id=5b718fc8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b718fc8"]])

export default __exports__